import { getProgressBarToken } from "../fundations/palette/colorTokens";
export const Progress = {
    MuiLinearProgress: {
        defaultProps: {
            variant: "determinate"
        },
        styleOverrides: {
            root: ({ theme })=>({
                    backgroundColor: getProgressBarToken("trackBackground1", theme)
                })
        }
    }
};

//# sourceMappingURL=Progress.js.map